import { FC } from 'react';

import {
  Container,
  SpinnerWrapper,
} from './DashboardLoadingIcon.styled';

interface DashboardLoadingIconProps {
  /** @deprecated rozmiar jest stały - prop zachowany dla kompatybilności */
  size?: 'sm' | 'md' | 'lg';
  title?: string;
  description?: string;
}

export const DashboardLoadingIcon: FC<DashboardLoadingIconProps> = () => (
  <Container>
    <SpinnerWrapper />
  </Container>
);
